// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/general.sass
// module id = 564
// module chunks = 0